module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-3-photo-8-26452974d58d9f87d7f73fb4e4eaf981.webp";